import { Component } from '@angular/core';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
})
export class GlobalSearchComponent {
public error:string;
}
